import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=59cb19ef&"
import script from "./svg-icon.vue?vue&type=script&lang=ts&"
export * from "./svg-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports